<template>
  <div
    v-if="Object.keys(seasonData).length > 0 && (seasonData.seasons.length > 0 || seasonData.has_gallery)"
    id="menu-seasons-component"
    class="text-white fs-6 mt-4 mb-4">
    <div class="row ms-0">
      <div class="col-12 red-color text-center">
        {{ title }}
      </div>
    </div>
  
    <div class="row ms-0">
      <div class="col-11 offset-1 border pt-2" id="seasons-container">
        <ul class="ps-0">
          <li
            v-if="seasonData.gallery_seasons.length > 0">
            <div
                class="container-accordion">
              <button
                class="border-0 bg-transparent text-white ps-0 fw-light text-18px text-capitalize"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#gallery'"
                :aria-controls="'#gallery'"
                @click="onGalleryClicked(null)">
                Galerie
              </button>
              <ul
                :id="'gallery'"
                class="accordion-collapse collapse text-capitalize">
                <li
                  v-for="item in seasonData.gallery_seasons"
                  :key="item"
                  class="episodes text-18px"
                  @click="onGalleryClicked(item)">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>
          <li
            v-for="item in seasonData.seasons"
            :key="item.season"
          >
            <div
              class="container-accordion"
              v-if="item.episodes.length > 0 || item.has_gallery">
              <button
                class="border-0 bg-transparent text-white ps-0 fw-light text-18px text-capitalize"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#season-' + item.season.replace(' ', '-')"
                :aria-controls="'season-' + item.season.replace(' ', '-')"
                @click="onSeasonClicked(item.season)">
                {{ item.season }}
              </button>
              <ul
                :id="'season-' + item.season.replace(' ', '-')"
                class="accordion-collapse collapse">
                <li
                  v-if="item.has_gallery"
                  class="episodes text-18px text-capitalize"
                  @click="onGalleryClicked(item.season)">
                  Galerie
                </li>
                <li
                  v-for="episode in item.episodes"
                  :key="episode"
                  class="episodes text-18px"
                  @click="onEpisodeClicked(item.season, episode)">
                  Episode {{ episode }}
                </li>
              </ul>
            </div>
            <div
              v-else
              class="season-no-episodes text-18px text-capitalize"
              @click="onSeasonClicked(item.season)">
              {{ item.season }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div
    v-else
    class="h-0">
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

import { PhotoSeasonApi } from "@/api/photo-season-api"

import { useLanguageStore } from "@/stores/language";
import { usePhotoStore } from "@/stores/photo";
import { useRouterStore } from "@/stores/router";
import { useCategoryStore } from "@/stores/category";

import { TEXT_KEYS } from "@/constants";

export default class MenuSeasons extends Vue {
  languageStore = useLanguageStore()
  photoStore = usePhotoStore()
  routerStore = useRouterStore()
  categoryStore = useCategoryStore()

  TEXT_KEYS = TEXT_KEYS

  seasonData: Record<string, any> = {}

  api = new PhotoSeasonApi()

  title = ''

  params: Record<string, any> = {}

  get routerReloadIndex() {
    return this.routerStore.getRealoadIndex
  }

  created() {
    this.$watch(() =>
      this.$route.params,
      (toParams: any, _: any) => {
        this.update(this.$route)
      }
    )
  }

  async mounted() {
    console.log("MenuSeasons Mounted", this.$route)

    this.update(this.$route)
  }

  async update(route: any) {
    console.log("MenuSeasons update", route)

    const params = {
      ...route.params,
      ...route.query
    }

    if (params.fromHome) {
      const fromHome: boolean = JSON.parse(params.fromHome)
      console.log("MenuSeasons update fromHome", fromHome)

      if (fromHome) {
        return;
      }
    }

    this.params = params

    if ('search_text' in  this.params) {
      this.setTitle(params)

      this.getSeasons(params)
    } else {
      this.seasonData = {}
    }
  }

  setTitle(params: Record<string, any>) {
    console.log("setTitle", params)

    let title = ''
    if ('sub_category_id' in params) {
      const categoryId = parseInt(params['category_id'])
      const subCategoryId = parseInt(params['sub_category_id'])

      title = this.categoryStore.getSubCategoryTitle(categoryId, subCategoryId, this.languageStore.getLanguageSelected)
    } else if ('category_id' in params) {
      const categoryId = parseInt(params['category_id'])

      title = this.categoryStore.getCategoryTitle(categoryId, this.languageStore.getLanguageSelected)
    } else if ('search_text' in params) {
      title = params['search_text']
    }

    this.title = title
  }

  async getSeasons(params: Record<string, any>) {
    console.log("MenuSeasons getSeasons", params)

    try {
      const response: any = await this.api.get(params)

      this.seasonData = response.data
    } catch (error) {
      console.error(error)
    }
  }

  public onGalleryClicked(season: string | null) {
    console.log("onGalleryClicked", season)

    const current_full_path = this.$router.currentRoute.value.fullPath

    let target_path = `/photos/season/search`
    let query = {}

    if ('search_text' in  this.params) {
      const searchText =  this.params['search_text']
      const searchType =  this.params['search_type']

      query = {
        search_type: searchType,
        search_text: searchText.toLowerCase(),
        is_gallery: true
      }

      if (season) {
        query = { ...query, ...{
          season: season
        }}
      }
    }

    if (current_full_path !== target_path) {
      // this.$router.push(target_path)
      this.$router.push({ path: target_path, query: query })
    } else {
      this.routerStore.incrementReloadIndex()
    }
  }

  public onSeasonClicked(season: string) {
    console.log("onSeasonClicked", season)

    const current_full_path = this.$router.currentRoute.value.fullPath

    let target_path = `/photos/season/search`
    let query = {}

    if ('search_text' in  this.params) {
      const searchText =  this.params['search_text']
      const searchType =  this.params['search_type']

      query = {
        search_type: searchType,
        search_text: searchText.toLowerCase(),
        season: season
      }
    }

    if (current_full_path !== target_path) {
      // this.$router.push(target_path)
      this.$router.push({ path: target_path, query: query })
    } else {
      this.routerStore.incrementReloadIndex()
    }
  }

  public onEpisodeClicked(season: string, episode: string) {
    console.log("onEpisodeClicked", season, episode)

    const current_full_path = this.$router.currentRoute.value.fullPath

    let target_path = `/photos/season/search`
    let query = {}

    if ('search_text' in  this.params) {
      const searchText =  this.params['search_text']
      const searchType =  this.params['search_type']

      query = {
        search_type: searchType,
        season: season,
        episode: `episode ${episode}`,
        search_text: searchText.toLowerCase()
      }
    }

    if (current_full_path !== target_path) {
      // this.$router.push(target_path)
      this.$router.push({ path: target_path, query: query })
    } else {
      this.routerStore.incrementReloadIndex()
    }
  }
}
</script>

<style lang="stylus">
#seasons-container {
  border-color: #e2001a !important
}

#seasons-container > ul > li {
  list-style-type: none
  text-align: left
}

.season-item:hover{
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}

.container-accordion > ul > li {
  list-style-type: none
}

.container-accordion > button:hover {
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}

.season-no-episodes:hover{
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}

.episodes:hover{
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}
</style>